import { ENABLE_DISABLE_BUTTON_ON_API_CALL } from '../actions/actionTypes';

const initialState: boolean = false;

export const buttonStateReducer = (state: boolean = initialState, action: any) => {

  switch (action.type) {
      
    case ENABLE_DISABLE_BUTTON_ON_API_CALL:
      return  action.data
    default:
      return state;
  }
};